import React from "react";
import { FaTelegramPlane } from "react-icons/fa"; // Import the Telegram icon
import "./telegramLink.css"; // Optional: Custom styling for the icon

const TelegramLink = () => {
  return (
    <div className="telegram-icon">
      <a
        href="https://t.me/+Lh0e9tydgQUxM2Ex" // Replace with your Telegram link
        target="_blank"
        rel="noopener noreferrer"
        title="Join us on Telegram"
      >
        <FaTelegramPlane />
      </a>
    </div>
  );
};

export default TelegramLink;
